import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import {
    Avatar,
    Box,
    Button,
    Card,
    Typography
} from '@mui/material';
import KonsolLogo from '../logo/KonsolLogo';


export default function LoginView(props) {


    const { isLoading, loginWithRedirect } = useAuth0();

    return (
        <React.Fragment>
            <Box
                height={'100vh'}
                width={'100%'}
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
            >
                <Card
                    sx={{
                        background: 'rgba(48, 89, 69, 0.2)',
                        borderRadius: '16px',
                        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.5)',
                        backdropFilter: 'blur(4.5px)',
                        transitionProperty: 'box-shadow',
                        transitionDuration: '1s',
                        width: 400,
                        height: 540
                    }}>
                    <Box 
                        display={'flex'}
                        height={'100%'}
                        flexDirection={'column'}
                    >
                        <Box 
                            display={'flex'}
                            justifyContent={'center'}
                            pt={5}
                        >
                            <KonsolLogo
                                isLoading={false}
                                width={300}
                                height={76}
                            />
                        </Box>
                        <Box
                            display='flex'
                            justifyContent='center'
                            height='45px'
                            py={2}
                        />
                        <Button
                            onClick={loginWithRedirect}
                            sx = {{ height: '270px', textTransform: 'none' }}
                        >
                            <Box
                                display={'flex'}
                                justifyContent={'center'}
                                flexDirection={'column'}
                                width={'100%'}
                                height={'100%'}
                            >
                                <Typography component="span" variant="h6" color="rgba(177,236, 175, 0.9)" paddingBottom="50px" paddingTop="10px">
                                    {isLoading ? 'Loading...' : 'Login'}
                                </Typography>
                            </Box>
                        </Button>
                    </Box>
                </Card>
            </Box>
        </React.Fragment>
    )
}